import {
  CREATE_LIST_PRODUCT_INVOICE,
  CREATE_LIST_PRODUCT_INVOICE_FAIL,
  CREATE_LIST_PRODUCT_INVOICE_SUCCESS,
  CREATE_PRODUCT_INVOICE,
  CREATE_PRODUCT_INVOICE_FAIL,
  CREATE_PRODUCT_INVOICE_SUCCESS,
  DELETE_PRODUCT_INVOICE,
  DELETE_PRODUCT_INVOICE_FAIL,
  DELETE_PRODUCT_INVOICE_SUCCESS,
  EDIT_PRODUCT_INVOICE,
  EDIT_PRODUCT_INVOICE_FAIL,
  EDIT_PRODUCT_INVOICE_SUCCESS,
  GET_ALL_PRODUCT_INVOICE,
  GET_ALL_PRODUCT_INVOICE_FAIL,
  GET_ALL_PRODUCT_INVOICE_SUCCESS,
  GET_DETAIL_PRODUCT_INVOICE,
  GET_DETAIL_PRODUCT_INVOICE_FAIL,
  GET_DETAIL_PRODUCT_INVOICE_SUCCESS,
  GET_LIST_PRODUCT_INVOICE,
  GET_LIST_PRODUCT_INVOICE_FAIL,
  GET_LIST_PRODUCT_INVOICE_SUCCESS,
  GET_LIST_VAT,
  GET_LIST_VAT_FAIL,
  GET_LIST_VAT_SUCCESS,
  RESET_CREATE_LIST_PRODUCT_INVOICE,
  RESET_CREATE_PRODUCT_INVOICE,
  RESET_DELETE_PRODUCT_INVOICE,
  RESET_EDIT_PRODUCT_INVOICE,
  RESET_GET_ALL_PRODUCT_INVOICE,
  RESET_GET_LIST_VAT,
  RESET_LIST_PRODUCT_INVOICE,
  SET_COLUMN_VISIBLE_PRODUCT_INVOICE,
} from "./actionTypes";

// sản phẩm/ dịch vụ
export const getListProductInvoice = params => ({
  type: GET_LIST_PRODUCT_INVOICE,
  params,
});

export const getListProductInvoiceSuccess = (listData, totalCount) => ({
  type: GET_LIST_PRODUCT_INVOICE_SUCCESS,
  listData,
  totalCount,
});

export const getListProductInvoiceFail = error => ({
  type: GET_LIST_PRODUCT_INVOICE_FAIL,
  error,
});

export const resetListProductInvoice = error => ({
  type: RESET_LIST_PRODUCT_INVOICE,
});

// Chi tiết sản phẩm/ dịch vụ
export const getDetailProductInvoice = id => ({
  type: GET_DETAIL_PRODUCT_INVOICE,
  id,
});

export const getDetailProductInvoiceSuccess = data => ({
  type: GET_DETAIL_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const getDetailProductInvoiceFail = error => ({
  type: GET_DETAIL_PRODUCT_INVOICE_FAIL,
  error,
});

// Tạo sản phẩm/ dịch vụ
export const createProductInvoice = data => ({
  type: CREATE_PRODUCT_INVOICE,
  data,
});

export const createProductInvoiceSuccess = data => ({
  type: CREATE_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const createProductInvoiceFail = error => ({
  type: CREATE_PRODUCT_INVOICE_FAIL,
  error,
});
export const resetCreateProductInvoice = error => ({
  type: RESET_CREATE_PRODUCT_INVOICE,
});

// Tạo list sản phẩm/ dịch vụ
export const createListProductInvoice = data => ({
  type: CREATE_LIST_PRODUCT_INVOICE,
  data,
});

export const createListProductInvoiceSuccess = data => ({
  type: CREATE_LIST_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const createListProductInvoiceFail = error => ({
  type: CREATE_LIST_PRODUCT_INVOICE_FAIL,
  error,
});
export const resetCreateListProductInvoice = error => ({
  type: RESET_CREATE_LIST_PRODUCT_INVOICE,
});

// EDIT sản phẩm/ dịch vụ
export const editProductInvoice = (data, id) => ({
  type: EDIT_PRODUCT_INVOICE,
  data,
  id,
});

export const editProductInvoiceSuccess = data => ({
  type: EDIT_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const editProductInvoiceFail = error => ({
  type: EDIT_PRODUCT_INVOICE_FAIL,
  error,
});
export const resetEditProductInvoice = error => ({
  type: RESET_EDIT_PRODUCT_INVOICE,
});

// Delete sản phẩm/ dịch vụ
export const deleteProductInvoice = id => ({
  type: DELETE_PRODUCT_INVOICE,
  id,
});

export const deleteProductInvoiceSuccess = data => ({
  type: DELETE_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const deleteProductInvoiceFail = error => ({
  type: DELETE_PRODUCT_INVOICE_FAIL,
  error,
});

export const resetDeleteProductInvoice = error => ({
  type: RESET_DELETE_PRODUCT_INVOICE,
});

// Get list Vat
export const getListVat = () => ({
  type: GET_LIST_VAT,
});

export const getListVatSuccess = data => ({
  type: GET_LIST_VAT_SUCCESS,
  data,
});

export const getListVatFail = error => ({
  type: GET_LIST_VAT_FAIL,
  error,
});

export const resetGetListVat = error => ({
  type: RESET_GET_LIST_VAT,
});

// getAllProductInvoice
export const getAllProductInvoice = () => ({
  type: GET_ALL_PRODUCT_INVOICE,
});

export const getAllProductInvoiceSuccess = data => ({
  type: GET_ALL_PRODUCT_INVOICE_SUCCESS,
  data,
});

export const getAllProductInvoiceFail = error => ({
  type: GET_ALL_PRODUCT_INVOICE_FAIL,
  error,
});

export const resetGetAllProductInvoice = error => ({
  type: RESET_GET_ALL_PRODUCT_INVOICE,
});

// show/hide column
export const setColumnVisibleProductInvoice = (field, value) => ({
  type: SET_COLUMN_VISIBLE_PRODUCT_INVOICE,
  field,
  value,
});
